import React, { MouseEventHandler } from "react"

import { WOWNET_CONTENT } from "@shared/constants"
import { useSchedule } from "@shared/contexts"

import { WownetContentType } from "live/constants"

import Button from "./Button"

const Partner = () => {
  const { schedule } = useSchedule()
  const streamerUsername = schedule?.user.username

  const handleLinkPartner: MouseEventHandler = (e) => {
    e.preventDefault()

    window.open(
      `${WOWNET_CONTENT.link}/?type=${WownetContentType.HOME}&analid=${streamerUsername}`,
    )
  }

  return (
    <Button
      label="파트너 홈"
      className="quickPartner"
      onClick={handleLinkPartner}
    />
  )
}

export default Partner
